import React from 'react';
import { styled } from '../../theme';

export type HelperTextWidget = {
  message: string;
};

export const HelperTextWidget = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.text.secondary};
  text-align: center;
`;
